import React from "react";
import "../style.css";

const ContactButtons = () => {
  return (
    <div className="cb-floating-wrapper">
      {/* Call - Number 1 */}
      <a href="tel:+919415799879" className="cb-call-btn">
        <img
          src="https://img.icons8.com/color/48/phone.png"
          alt="Call 1"
          className="cb-icon"
        />
      </a>

     

      {/* WhatsApp */}
      <a
        href="https://wa.me/919415799879"
        target="_blank"
        rel="noopener noreferrer"
        className="cb-whatsapp-btn"
      >
        <img
          src="https://img.icons8.com/color/48/whatsapp--v1.png"
          alt="WhatsApp"
          className="cb-icon"
        />
      </a>
    </div>
  );
};

export default ContactButtons;
